import { TIPO_DOCUMENTO_DB } from "common/utils/documentos"
import { formatSerieAndNumero } from "common/utils/formats"
import { nanoid } from "nanoid"
import { useTranslation } from "react-i18next"
import ArchivosAdjuntosFileItem from "../ArchivosAdjuntosFileItem"

const ModalVerDocumentosDocumetosAsosiados = ({
  documentosAsociados,
  descargarDocumentoAsociado,
}: $TSMigrationFixMe) => {
  const { t } = useTranslation()
  return (
    <>
      <div className='mt-3 mb-3'>
        <strong>{t("crear.presupuesto.modal.associatedDocLabel")}</strong>
      </div>

      {documentosAsociados?.map((documentoAsociado: $TSMigrationFixMe) => {
        const nombreTipoDeDocumento =
          // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre...
          TIPO_DOCUMENTO_DB[documentoAsociado.tipoDocumento]
        const nombreDocumento = `${nombreTipoDeDocumento}: ${formatSerieAndNumero(
          {
            serie: documentoAsociado.serie,
            numero: documentoAsociado.numero,
          }
        )}`

        return (
          <ArchivosAdjuntosFileItem
            key={nanoid()}
            name={nombreDocumento}
            onDownload={() =>
              descargarDocumentoAsociado({
                ...documentoAsociado,
                nombre: nombreDocumento,
              })
            }
          />
        )
      })}
    </>
  )
}

export default ModalVerDocumentosDocumetosAsosiados
